/* import __COLOCATED_TEMPLATE__ from './screen-config-editor-column.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class ScreenConfigEditorColumnComponent extends Component
{
	// Available column names
	columnNames = [
		'Place', 'Bib', 'Name', 'Class', 'Club', 'Time', 'TimeBack',
		'Splits', 'Country', 'State', 'RelayName'
	];

	// Available variants per column type
	variantOptions = {
		'Name': ['', 'doubleLine'],
		'Class': ['', 'links'],
		'Time': ['', 'split'],
		'Splits': ['', 'singleSplit']
	};

	get hasVariants()
	{
		return this.variantOptions[this.args.column.name] !== undefined;
	}

	get availableVariants()
	{
		return this.variantOptions[this.args.column.name] || [];
	}

	get showSplitName()
	{
		return this.args.column.name === 'Splits' && this.args.column.variant === 'singleSplit';
	}

	@action updateField(field, event)
	{
		let value = event.target.value;
		// Convert width to number if present
		if (field === 'width' && value) {
			value = parseInt(value) || '';
		}
		this.args.onUpdate({ ...this.args.column, [field]: value });
	}

	@action updateName(event)
	{
		const newName = event.target.value;
		// Reset variant when changing name
		const updated = { ...this.args.column, name: newName };
		if (!this.variantOptions[newName]) {
			delete updated.variant;
		}
		this.args.onUpdate(updated);
	}
}
